import React, {useEffect, useState} from 'react';
import ModalImage from "../modal/modal-image.jsx";
import {Modal} from "../modal/modal.jsx";
import Button from "../button/button.jsx";
import {Card} from "../card/card.jsx";
import ChatMessage from "./chat-message.jsx";
import {useQuery} from "@tanstack/react-query";
import axios from "axios";

const ChatHistory = ({url, title = "Histórico do chat", height = "h-full", dataCallback}) => {
    const [imageModal, setImageModal] = useState({open: false, imgSrc: undefined});
    const [videoModal, setVideoModal] = useState({open: false, videoSrc: undefined});

    const {data, isSuccess, isError, isLoading, refetch} = useQuery({
        queryFn: () => axios.get(url).then(({data}) => {
            if (data?.chat) {
                data.chat.result.updated = data.chat.result.updated.reverse().filter(message => !message.t);
            }

            return data;
        }),
        queryKey: ["chat", url]
    });

    useEffect(() => {
        if (!data) return;

        if (data.status === "BACKUP_ONGOING") {
            setTimeout(() => { refetch() }, 2000)
        }

        if (dataCallback) dataCallback(data);
    }, [data]);

    return (
        <>
            <Card className={height}>
                <Card.Header className={"!bg-white !justify-center rounded-t-[10px]"}>
                    <Card.Title className={"!bg-white"}>{title}</Card.Title>
                </Card.Header>
                <Card.Body className={"!p-0 " + (isSuccess && data.status === "SUCCESS" ? "h-[calc(100%-32px)]" : "h-full")}>
                    {
                        (isLoading || (isSuccess && data.status === "BACKUP_ONGOING")) &&
                        <div className={"h-full flex items-center justify-center gap-2"}>
                            <span className="inline-block size-5 rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] animate-spin text-gray-300"/>
                            Carregando chat…
                        </div>
                    }

                    {
                        (isError || (isSuccess && data.status !== "SUCCESS" && data.status !== "BACKUP_ONGOING")) &&
                        <div className={"h-full flex items-center flex-col justify-center gap-2"}>
                            <h5>Aviso</h5>
                            <p className="card-text">
                                { isError && "Não foi possível abrir o chat" }
                                { (isSuccess && data.status === "NOT_FOUND") && "Não há chat para esse SOS" }
                            </p>
                            <Button onClick={() => refetch()}>
                                Tentar novamente
                            </Button>
                        </div>
                    }

                    {
                        isSuccess && data.status === "SUCCESS" &&
                        <ul className={"chat-body"}>
                            {
                                data.chat.result.updated.map((message) => (
                                    <ChatMessage
                                        key={message._id}
                                        message={message}
                                        setImageModal={setImageModal}
                                        setVideoModal={setVideoModal}
                                        history={true}
                                    />
                                ))
                            }
                        </ul>
                    }
                </Card.Body>
            </Card>

            <ModalImage
                open={imageModal.open}
                setOpen={() => setImageModal({open: false, imgSrc: undefined})}
                imgUrl={imageModal.imgSrc}
            />

            <Modal open={videoModal.open} setOpen={() => setVideoModal({open: false, videoSrc: undefined})}
                   title={"Vídeo"}>
                <Modal.Body className="pb-2 align-self-center justify-items-center max-h-[calc(100vh-200px)]">
                    <div className={"w-auto h-[calc(100vh-230px)]"}>
                        <video className={"video-component"} controls>
                            <source src={videoModal.videoSrc} type="video/mp4"/>
                        </video>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button target="primary" onClick={() => setVideoModal({open: false, videoSrc: undefined})}>
                        Ok
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ChatHistory;